import React from "react";
import "./Presentation.css";
import PresentationImage from "../../assets/img/Pix.png";
import {ReactComponent as ArrowRight} from "../../assets/img/svg/arrow-right.svg";
import {Link} from "react-router-dom";

const Presentation = () => {
    return (
        <>
            <div className="presentation-container">
                <div className="presentation-image"></div>
                <div className="presentation-content">
                    <img src={PresentationImage} alt={"Presentation"}/>
                    <div className="presentation-text-container">
                        <h4>Guillaume Deneufbourg</h4>
                        <div className="line-container">
                            <div className="line"/>
                            <h5>polyglotte passionné, traducteur soucieux du travail bien fait</h5>
                        </div>
                        <div className="presentation-content-text">
                            <p className="regular">
                                Je suis traducteur en profession libérale. Je traduis des articles de presse, de la littérature et différents types de documents, rapports et allocutions politiques et diplomatiques.
                            </p>
                            <Link to={"/bio"} className="text-decoration-none">
                                <button className="secondary">
                                    En savoir plus
                                    <ArrowRight className="arrow-right"/>
                                </button>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Presentation;
